import React from "react";
import { Card, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { HelpTooltip } from "../assets/functions.js";

export function AnalyticsHelp({ text }) {
  if (!text) return null;

  return (
    <OverlayTrigger overlay={<Tooltip>{text}</Tooltip>}>
      <HelpTooltip icon={faExclamationCircle} className="analytics-help-icon" />
    </OverlayTrigger>
  );
}

export function AnalyticsKpiCard({ title, value, subtitle, subtitleContent, icon, tooltip, iconSize, className = "" }) {
  return (
    <Col sm={6} xl={3} className={`mb-3 analytics-kpi-card ${className}`.trim()}>
        <Card className="h-100">
            <Card.Body>
                <div className="analytics-kpi-card-header">
                    <span className="analytics-kpi-icon text-primary" aria-hidden="true">
                        <FontAwesomeIcon icon={icon} size={iconSize} />
                    </span>
                    <div className="analytics-kpi-title small text-muted">
                        {title}
                        <AnalyticsHelp text={tooltip} />
                    </div>
                </div>
                <div className="analytics-kpi-card-content">
                    <h4 className="analytics-kpi-value">{value}</h4>
                    {(subtitle || subtitleContent) && <div className="analytics-kpi-subtitle text-muted small">{subtitleContent || subtitle}</div>}
                </div>
            </Card.Body>
        </Card>
    </Col>
  );
}
